import { Route, Routes } from "react-router-dom";
import OutfittingTable from "../component/outfitting/OutfittingTable";

const OutfittingPlanning = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<OutfittingTable />} />
      </Routes>
    </div>
  );
};

export default OutfittingPlanning;
